<div class="section" *ngIf="loadedSignals">
  <div class="header">
    <h3 class="title">{{ 'pages.dashboard.worldwatch' | translate }}</h3>
  </div>
  <ngb-carousel #carousel [interval]="5000" >
    <ng-template ngbSlide *ngFor="let sig of latestSignals; index as i" >
        <div class="carousel" [routerLink]="['/updates/worldwatch/viewSignal/' + sig.jiraRef]" routerLinkActive="router-link-active">
              <div class="logo" [ngClass]="sig.signalUrgency + sig.mainCategory | lowercase | removeWhiteSpace"></div>
              <div class="summary">
                <span>{{sig.summary}}</span>
              </div>
              <div class="published">
                <fa-icon class="me-2" icon="calendar"></fa-icon>{{sig.publishDateObj | date:'MM/dd/yyyy h:mm a'}}
              </div>
              <span class="whatYouWillHear">
                {{sig.whatYouWillHear}}
              </span>
        </div>
    </ng-template>
  </ngb-carousel>

  <div class="row justify-content-center orangeText" *ngIf="loadedSignals && !latestSignals">
    <fa-icon [icon]="['fas', 'exclamation-circle']" size="2x"></fa-icon>
  </div>
</div>

<div class="row justify-content-center p-5" *ngIf="!loadedSignals">
  <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
  </div>
</div>
